module.exports = __webpack_public_path__ + "top_page/top-industry-service-b031ce03f23c9f4c9e443e4c4e1d72af.svg";